export default "__VITE_ASSET__DXGsH2g___"